if (!customElements.get('card-reviews')) {
  class CardReviews extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.card-reviews__slide'));
      this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;

      this.arrow = this.querySelector('.card-reviews__arrow');
      if (this.arrow) {
        this.arrow.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.showNext();
        });
      }
    }

    showNext() {
      if (this.slides.length < 2) return;
      this.slides[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
    }
  }

  customElements.define('card-reviews', CardReviews);
}
